export const SET_CONNECTED = 'SET_CONNECTED'
export const SET_WEBSOCKET_AUTH = 'SET_WEBSOCKET_AUTH'
export const SET_WEBSOCKET_AUTHENTICATED = 'SET_WEBSOCKET_AUTHENTICATED'
export const SET_WEBSOCKET_AUTH_ERROR = 'SET_WEBSOCKET_AUTH_ERROR'
export const RESET_WEBSOCKET = 'RESET_WEBSOCKET'
export const RESET_WEBSOCKET_AUTH = 'RESET_WEBSOCKET_AUTH'
